import { getAsync, postAsync } from './_base';

let payAccountApiUrl: '/Components/Service/UserService.asmx/RequestForPayByAccountNew';
let registerApiUrl: '/Components/Service/UserService.asmx/RegisterUserNew';

export const checkUserExists = (email: string, apiUrl: string) => {
  return postAsync(apiUrl, undefined, `"${email}"`, false, false, true);
};

export const sendRequestPayByAccount = (data: string, countryCode: string, apiUrl?: string) => {
  return postAsync(apiUrl ?? payAccountApiUrl, undefined, data);
};

export const sendRegister = (data: any, countryCode: string, apiUrl?: string) => {
  const formData = new FormData();
  formData.append('jsonRequest', JSON.stringify(data));
  return postAsync(apiUrl ?? registerApiUrl, undefined, formData);
};

export const getUserDetail = (apiUrl: string) => {
  return getAsync(apiUrl);
};

export const updateUser = (data: any, apiUrl: string) => {
  const formData = new FormData();
  formData.append('jsonRequest', JSON.stringify(data));
  return postAsync(apiUrl, undefined, formData);
};

export const sendRequestResetPassword = (email: string, apiUrl: string) => {
  return postAsync(apiUrl, undefined, `"${email}"`);
};

export const updateNewPassword = (email: string, password: string, confirmation: string, customerNumber: string, apiUrl: string) => {
  return postAsync(apiUrl, undefined, { username: email, password, confirmation, customerNumber });
};
